import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { getSalesReps } from '../../api'; 
import { isPropietarioOrAdminOrGestion, isJefeComerciales } from '../../services/AuthService';
import MultiSalesRepSelector from './MultiSalesRepSelector'; 

const ClientSearchForm = ({ onSearch, userRole, includeDisabled = false, initialFilters = {}, onChangeFilters }) => {
  const emptyState = {
    id: '',
    dni: '',
    name: '',
    lastName1: '',
    lastName2: '',
    phone: '',
    email: '',
    dateOfBirth: '',
    salesRepId: [],
    address: '',
    city: '',
    district: '',
    state: '',
    zipCode: '',
    country: ''
  };

  const [searchCriteria, setSearchCriteria] = useState({ ...emptyState, ...initialFilters });

  const [salesReps, setSalesReps] = useState([]); // Para almacenar los comerciales
  const [loadingSalesReps, setLoadingSalesReps] = useState(false); // Para gestionar el estado de carga

  // Verificar si el usuario es admin o owner, y cargar los comerciales si no lo es
  useEffect(() => {
    const fetchSalesReps = async () => {
      const isPrivileged = isPropietarioOrAdminOrGestion();
      const isJefe = isJefeComerciales();
      if (isPrivileged || isJefe) {
        setLoadingSalesReps(true);
        try {
          const reps = await getSalesReps();

          setSalesReps(reps);
        } catch (error) {
          console.error('Error fetching sales reps:', error);
        } finally {
          setLoadingSalesReps(false);
        }
      }
    };

    fetchSalesReps();
  }, [userRole]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchCriteria(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filteredCriteria = Object.fromEntries(
      Object.entries(searchCriteria).filter(([key, value]) => value !== '' && value !== null && !(Array.isArray(value) && value.length === 0))
    );
    onChangeFilters && onChangeFilters(filteredCriteria);
    onSearch && onSearch(filteredCriteria);
  };

  const handleReset = () => {
    setSearchCriteria(emptyState);
    onChangeFilters && onChangeFilters({});
    onSearch && onSearch({});
  };

  return (
    <div>
      <h3>Buscar Clientes</h3>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="id">
              <Form.Label>ID Cliente</Form.Label>
              <Form.Control
                type="number"
                name="id"
                value={searchCriteria.id}
                onChange={handleInputChange}
                placeholder="ID Cliente"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="dni">
              <Form.Label>DNI</Form.Label>
              <Form.Control
                type="text"
                name="dni"
                value={searchCriteria.dni}
                onChange={handleInputChange}
                placeholder="DNI"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="searchName">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={searchCriteria.name}
                onChange={handleInputChange}
                placeholder="Nombre"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="lastName1">
              <Form.Label>Apellido 1</Form.Label>
              <Form.Control
                type="text"
                name="lastName1"
                value={searchCriteria.lastName1}
                onChange={handleInputChange}
                placeholder="Apellido 1"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="lastName2">
              <Form.Label>Apellido 2</Form.Label>
              <Form.Control
                type="text"
                name="lastName2"
                value={searchCriteria.lastName2}
                onChange={handleInputChange}
                placeholder="Apellido 2"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="phone">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                name="phone"
                value={searchCriteria.phone}
                onChange={handleInputChange}
                placeholder="Teléfono"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={searchCriteria.email}
                onChange={handleInputChange}
                placeholder="Email"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="dateOfBirth">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={searchCriteria.dateOfBirth}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>

          {(isPropietarioOrAdminOrGestion() || isJefeComerciales()) && (
            <Col xs={12} md={6} lg={4}>
              {loadingSalesReps ? (
                <Form.Group>
                  <Form.Label>Comercial</Form.Label>
                  <Form.Control as="select" disabled>
                    <option>Cargando...</option>
                  </Form.Control>
                </Form.Group>
              ) : (
                <MultiSalesRepSelector
                  salesReps={salesReps}
                  selectedIds={searchCriteria.salesRepId}
                  onChange={(ids) => setSearchCriteria(prev => ({ ...prev, salesRepId: ids }))}
                  label="Comercial"
                  placeholder="Seleccionar comerciales"
                />
              )}
            </Col>
          )}

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="address">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                type="text"
                name="address"
                value={searchCriteria.address}
                onChange={handleInputChange}
                placeholder="Dirección"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="city">
              <Form.Label>Ciudad</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={searchCriteria.city}
                onChange={handleInputChange}
                placeholder="Ciudad"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="district">
              <Form.Label>Distrito</Form.Label>
              <Form.Control
                type="text"
                name="district"
                value={searchCriteria.district}
                onChange={handleInputChange}
                placeholder="Distrito"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="state">
              <Form.Label>Estado</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={searchCriteria.state}
                onChange={handleInputChange}
                placeholder="Estado"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="zipCode">
              <Form.Label>Código Postal</Form.Label>
              <Form.Control
                type="text"
                name="zipCode"
                value={searchCriteria.zipCode}
                onChange={handleInputChange}
                placeholder="Código Postal"
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group controlId="country">
              <Form.Label>País</Form.Label>
              <Form.Control
                type="text"
                name="country"
                value={searchCriteria.country}
                onChange={handleInputChange}
                placeholder="País"
              />
            </Form.Group>
          </Col>
        </Row>

        <Button type="submit" variant="primary" className="me-2">
          Buscar
        </Button>
        <Button type="button" variant="secondary" onClick={handleReset}>
          Resetear Filtros
        </Button>
      </Form>
    </div>
  );
};

export default ClientSearchForm;
